/* eslint-disable import/prefer-default-export */

/**
 * The number of items to display on a single page in a paginated listing.
 *
 * @type {number}
 */
export const PAGE_SIZE = 10;
